// 9fbef606107a605d69c0edbcd8029e5d
import has from 'lodash/has';
import get from 'lodash/get';
import { router } from 'next/router';
import { breakpoints } from '@tcp/core/styles/themes/TCP/mediaQuery';
import { getImageUrls } from '../../../../common/atoms/DamImage/views/DamImage';
import { getAPIConfig } from '../../../../../utils';
import { cleanUpUrl, getImageSource } from '../../../../common/atoms/DamImage/utils/DamImageUtils';

const PDPCarouselOptions = {
  CAROUSEL_OPTIONS: {
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 6,
    slide: true,
    touchMove: true,
    touchThreshold: 100,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: breakpoints.values.lg - 1,
        settings: {
          arrows: false,
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: breakpoints.values.sm - 1,
        settings: {
          arrows: false,
          slidesToShow: 2.8,
          slidesToScroll: 1,
        },
      },
    ],
  },
};

export default {
  PDPCarouselOptions,
};

export function getVariantsForSeo(product) {
  const { hostname } = getAPIConfig();
  const { state: { asPath = '' } = {} } = router || {};
  if (has(product, 'variantsSeoData')) {
    const variants = get(product, 'variantsSeoData') || [];
    if (Array.isArray(variants) && variants.length) {
      const { assetHostTCP: assetHost } = getAPIConfig();
      return variants?.map((variant) => {
        const { availability } = variant || {};
        const isAvailable = parseInt(availability, 10) > 0;
        const { desktop } = getImageUrls(
          { url: variant?.image },
          variant?.brand,
          true,
          variant?.brand
        );
        const cleanUrl = cleanUpUrl(desktop);
        const imageSource = getImageSource(
          assetHost,
          'd_pdp_img_d,f_auto,q_auto',
          cleanUrl,
          desktop
        );
        return {
          '@type': 'Product',
          name: `${product?.name} - ${variant?.color}`,
          description: `${variant?.description}`,
          sku: variant?.sku,
          color: variant?.color,
          isFamilyFriendly: true,
          image: imageSource,
          brand: {
            '@type': 'Brand',
            name: variant?.brand,
          },
          offers: {
            '@type': 'Offer',
            price: variant?.price,
            url: `https://${hostname}${asPath}`,
            priceCurrency: 'USD',
            availability: `https://schema.org/${isAvailable ? 'InStock' : 'OutOfStock'}`,
            itemCondition: 'https://schema.org/NewCondition',
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: variant?.ratingValue,
            bestRating: '5',
            reviewCount: variant?.reviewCount,
            worstRating: '1',
          },
        };
      });
    }
  }
  return [];
}
